require('jquery')
require('bootstrap')
require('@fortawesome/fontawesome-free')
require('slick-carousel')
require('jquery-mask-plugin/dist/jquery.mask.min')
require('@fancyapps/fancybox')

window._ = require('lodash')

require('./partials/banner')
require('./partials/slick')
require('./partials/packery')
require('./partials/switchHeader')
require('./partials/headerClose')

try {
  window.Popper = require('@popperjs/core').default
  window.$ = window.jQuery = require('jquery')
} catch (e) {}

jQuery(function () {
  menuLoadingPage()
  mainHeight()
  toggleIconPlus()
  themeColor()
  masks()

  $(window).scroll(function () {
    menuLoadingPage()
    mainHeight()
  })

  $(window).on('resize', function () {
    menuLoadingPage()
    mainHeight()
  })

  $(window).ready(function () {
    menuLoadingPage()
    mainHeight()
    masks()
  })

  $(window).on('load', function () {
    menuLoadingPage()
    mainHeight()
  })

  // Toggle icon plus for minus(tags blog)
  function toggleIconPlus() {
    $('.plusCollapse').on('click', function () {
      $(this).find('i').toggleClass('fa-plus fa-minus')
    })
  }

  //Adiciona margin entre header e a sessao, quando o header for fixo
  function mainHeight() {
    $('header').next().not($('.behind')).css('margin-top', $('.header2').outerHeight())

    //Adiciona margin entre header e a barra de administracao do WordPress se existir
    if ($('#wpadminbar')) {
      $('header').css('margin-top', $('#wpadminbar').outerHeight())
    }
  }

  //Adiciona cor principaldo thema nos meta tags do header
  function themeColor() {
    const themeColor = $(
      '[name="theme-color"], [name="msapplication-navbutton-color"], [name="msapplication-TileColor"]'
    )
    const value = getComputedStyle(document.documentElement).getPropertyValue('--bs-primary')
    themeColor.attr('content', value)
  }

  //Oculta Copyright NitroPack Plugin
  document.addEventListener('DOMContentLoaded', function () {
    let divc = document.querySelectorAll('div[style]')
    for (let i = 0, len = divc.length; i < len; i++) {
      let actdisplay = window.getComputedStyle(divc[i], null).display
      let actclear = window.getComputedStyle(divc[i], null).clear

      if (actdisplay == 'block' && actclear == 'both') {
        divc[i].remove()
      }
    }
  })

  function masks() {
    //Telefone
    var SPMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009'
      },
      spOptions = {
        onKeyPress: function (val, e, field, options) {
          field.mask(SPMaskBehavior.apply({}, arguments), options)
        }
      }
    $('.mask-phone , [type="tel"], [id="tel"]').mask(SPMaskBehavior, spOptions)
  }

  $('form [type=checkbox]').after('<span class="slider"></span>')

  //Caso o menu corresponda a um menu de Loading Page ou Onepage ele vincula os links com sessões do body
  function menuLoadingPage() {
    let valorDes = 100

    $('header .nav-link, footer .nav-link').each(function (i) {
      $('header .nav-link, footer .nav-link')
        .eq(i)
        .click(function () {
          let dataLink = $(this).attr('data-link')
          let Pagetop = $(dataLink)?.offset()?.top
          $('.navbar-toggler').trigger('click')
          $('html, body')
            .stop(true)
            .animate(
              {
                scrollTop: Pagetop - valorDes
              },
              700
            )
        })
    })

    let sections = $('section[id]')

    let scrollY = $(window).scrollTop()

    $(sections).each(function (i) {
      let sectionHeight = $(sections).eq(i).outerHeight()
      let sectionTop = $(sections).eq(i).offset().top - valorDes
      let sectionId = $(sections).eq(i).attr('id')

      if (scrollY >= sectionTop && scrollY <= sectionTop + sectionHeight) {
        $('.navbar-nav li a[data-link*="#' + sectionId + '"]')
          .closest('li')
          .addClass('active')
        $('.navbar-nav li a').eq(0).closest('li').removeClass('active')
      } else if (scrollY == 0) {
        $('.navbar-nav li a').eq(0).closest('li').addClass('active')
      } else {
        $('.navbar-nav li a[data-link*="#' + sectionId + '"]')
          .closest('li')
          .removeClass('active')
      }
    })
  }
})
